import React, { ReactElement } from "react";
import { useTranslation } from "next-i18next";
import { BreadCrumb } from "@kunduz/ui";
import { QuestionIndexing } from "@kunduz/data-access-qi-api";
import { getQIUrl } from "@kunduz/utility-common";

export const QIBreadcrumb = (props: Props): ReactElement => {
  const { t } = useTranslation("questionIndexing");

  function prepareBase() {
    if (props.lang == "tr") {
      return {
        label: t("question_indexing_breadcrumb_1st_item_label"),
        url: `/${props.lang}/`,
      };
    } else {
      return {
        label: t("question_indexing_breadcrumb_1st_item_label"),
        url: `/`,
      };
    }
  }

  function calculateItems() {
    const result: {
      label: string;
      url?: string;
      onClick?: () => void;
    }[] = [
      {
        label: t("question_indexing_breadcrumb_courses_label"),
        ...(Object.keys(props).length !== 1 && {
          url: getQIUrl({ lang: props.lang }),
        }),
      },
    ];

    if (props.question) {
      if (props.question?.course) {
        result.push({
          label: props.question?.course?.name,
          url: getQIUrl({
            lang: props.lang,
            courseSlug: props.question?.course?.slug,
          }),
        });
      }
      if (props.question?.subject) {
        result.push({
          label: props.question?.subject?.name,
          url: getQIUrl({
            lang: props.lang,
            courseSlug: props.question?.course?.slug,
            subjectSlug: props.question?.subject?.slug,
          }),
        });
      }
      if (props.question?.title) {
        result.push({
          label: `${props.question?.title?.substring(0, 48)}...`,
        });
      }
    } else if (props.subject) {
      if (props.course) {
        result.push({
          label: props.course?.name,
          url: getQIUrl({
            lang: props.lang,
            courseSlug: props.course?.slug,
          }),
        });
      }
      if (props.subject) {
        result.push({
          label: props.subject?.name,
        });
      }
    } else if (props.course) {
      result.push({
        label: props.course?.name,
      });
    }

    return result;
  }

  return (
    <BreadCrumb
      base={prepareBase()}
      items={calculateItems()}
      linkAs={props.linkAs}
    />
  );
};

interface Props {
  question?: QuestionIndexing.TrQiQuestion;
  course?: QuestionIndexing.IQiCourse;
  subject?: QuestionIndexing.IQiSubject;
  lang: "tr" | "en";
  linkAs?: React.ElementType;
}
